<rask-toggle-panel label="Anteckningar" [defaultExpanded]="false">
    @if(kontrakt$ | async; as kontrakt){
    <div class="row pb-3">
        <rask-textarea
            class="w-100 mt-0"
            #anteckningarInternTextArea
            label="Intern anteckning (Tänk på att inte skriva personuppgifter)"
            [rows]="3"
            [disabled]="readonly"
            [(ngModel)]="kontrakt.anteckningIntern"
            (ngModelChange)="onChange(kontrakt)"
            [maxlength]="2000">
        </rask-textarea>
    </div>
    <hr />
    @if (kontrakt.isAvverkning && isCvk && !kontrakt.isAnySkogsvard) {
    <div class="row pb-3">
        <rask-textarea
            class="w-100 mt-0"
            #anteckningarPlanerareTextArea
            label="Anteckning från planerare (ej till avverkningsdirektiv)"
            [rows]="3"
            [disabled]="readonly"
            [(ngModel)]="kontrakt.anteckningPlanerare"
            (ngModelChange)="onChange(kontrakt)"
            [maxlength]="2000">
        </rask-textarea>
    </div>
    }

    @if (kontrakt.isAvverkning && !kontrakt.isAnySkogsvard) {
    <div class="row form-spacing pb-36">
        <rask-textarea
            #anteckningarTextArea
            class="w-100"
            label="Anteckning till avverkningsdirektiv och maskinens apteringsfiler"
            [rows]="3"
            [disabled]="readonly"
            [(ngModel)]="kontrakt.anteckningAvverkningsdirektiv"
            (ngModelChange)="onChange(kontrakt)"
            [maxlength]="1998">
        </rask-textarea>
        <rask-checkbox
            [flexResize]="true"
            class="mt-0"
            label="Kontakt med planerare"
            id="kontrakt-anteckning-planerare-kontaktas-checkbox"
            text="Planerare ska kontaktas"
            [disabled]="readonly"
            [(ngModel)]="kontrakt.kontaktaPlaneraren"
            (ngModelChange)="onChange(kontrakt)"></rask-checkbox>
    </div>
    }
    }
</rask-toggle-panel>